import { createFileRoute } from '@tanstack/react-router';
import { useRegistrationGuard } from '@/hooks/use-registration-guard';
import { STEPS } from '@/features/cleaner/apply-cleaner/constant';
import { PersonalInfoStep } from '@/features/cleaner/apply-cleaner/steps/personal-info-step';

function PersonalInfoRoute() {
  useRegistrationGuard({
    requiredStep: STEPS.PERSONAL_INFO,
    requireAuth: true,
    redirectTo: '/apply-cleaner/signup',
  });

  return <PersonalInfoStep />;
}

export const Route = createFileRoute('/(cleaner)/apply-cleaner/personal-info')({
  component: PersonalInfoRoute,
});
